import React, { useState, useEffect, useRef } from 'react';
import { db } from '../../firebase'; // Firestore instance
import { collection, onSnapshot, arrayUnion, getDocs,addDoc, setDoc,query, orderBy } from 'firebase/firestore'; // Import onSnapshot for real-time updates
import Dropdown from 'react-bootstrap/Dropdown';
import DropdownButton from 'react-bootstrap/DropdownButton';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../Component/Component.css';
import { doc, updateDoc } from 'firebase/firestore';
import { Switch } from "@mui/material";
import { getDatabase, ref, set } from "firebase/database"; // Realtime Database imports
// import { db } from '../firebase';
const RelayDropdown = ({ onSelectRelay, user, changeLoaderStatus }) => {
    const [relays, setRelays] = useState([]);  // To store the fetched relays
    const [selectedRelay, setSelectedRelay] = useState({}); // To store the selected relay
    const selectedRelayRef = useRef({});
    const loggedUser = useRef({});
    const realtimeDb = getDatabase();
  
    // const [selectedRelay, setSelectedRelay] = useState({});
    // Fetch relays from Firestore in real-time
    useEffect(() => {
        changeLoaderStatus(true);
        loggedUser.current = user;

        const relayCollection = collection(db, 'relays'); // Reference to the 'relays' collection
        const relayQuery = query(relayCollection, orderBy("relay_id", "asc")); // Create a sorted query

        // Listen for real-time updates using onSnapshot
        const unsubscribe = onSnapshot(relayQuery, (snapshot) => {
            const relayList = snapshot.docs.map(doc => ({
                id: doc.id, // Get document ID
                ...doc.data() // Spread other fields (like relay_name)
            }));

            console.log(`User ID: ${loggedUser.current.id}`);
            if (loggedUser.current.is_admin) {
                console.log("Admin User detected");
                setRelays(relayList); // Set all relays for admin
            } else {
                console.log(`Non-admin User ${loggedUser.current.id}`);
                const filteredRelays = relayList.filter(relay =>
                    relay.allowed_users.includes(loggedUser.current.id)
                );
                setRelays(filteredRelays); // Set filtered relays for non-admin
            }

            // Handle the default selected relay
            if (selectedRelayRef.current.relay_id == null) {
                handleSelectChange(relayList[0]);
            }

            console.log("Refetch Data");
            if (selectedRelayRef.current != null) {
                const foundRelay = relayList.find(relay => relay.relay_id === selectedRelayRef.current.relay_id);
                if (foundRelay) {
                    console.log("Recall found relay");
                    handleSelectChange(foundRelay);
                } else {
                    console.warn('Selected relay is no longer available.');
                }
            }

            changeLoaderStatus(false); // Hide loader after processing
        }, (error) => {
            changeLoaderStatus(false); // Hide loader on error
            console.error("Error fetching relays:", error);
        });

        // Cleanup function to unsubscribe from Firestore listener when the component unmounts
        return () => unsubscribe();
    }, [user]);



    // Handle dropdown selection
    const handleSelectChange = (relay) => {
        setSelectedRelay(relay); // Set the selected relay name
        onSelectRelay(relay);
        selectedRelayRef.current = relay; // Trigger the callback function to pass the selected relay to the parent
    };



    const handleRelaySelect = (relay) => {
        setSelectedRelay(relay);  // Update the state with the selected relay
    };

    const updateRelayStatus = async (newStatus, relay, username) => {
        try {
            // Get the document reference for the specific relay by its id
            const relayDocRef = doc(db, 'relays', relay.relay_id.toString());

            // Get the current date and time
            const currentDateTime = new Date().toLocaleString();

            // Create the new history entry
            const newHistoryEntry = {
                date: currentDateTime,
                status: newStatus ? "1" : "0", // Assuming status "On" or "Off"
                user: user.username
            };

            // Update the relay_status and add a new entry to the history array
            await updateDoc(relayDocRef, {
                relay_status: newStatus ? 1 : 0,  // Update status as 1 (on) or 0 (off)
                history: arrayUnion(newHistoryEntry) // Append the new history entry to the history array
            });

            console.log(`Relay ${relay.relay_id} status updated to ${newStatus ? 1 : 0}`);
            console.log(`History updated with:`, newHistoryEntry);

            await updateRelayStatusesInRealtimeDatabase(db, realtimeDb);

        } catch (err) {
            console.error("Error updating relay status and history:", err);
        }
    };

    // const updateRelayStatusesInRealtimeDatabase = async (db, realtimeDb) => {
    //     try {
    //         // Get all relay documents from Firestore
    //         const relaysSnapshot = await getDocs(collection(db, 'relays'));

    //         // Initialize an empty string to hold the concatenated relay_status values
    //         let relayStatusString = '';

    //         // Loop through each relay document
    //         relaysSnapshot.forEach(doc => {
    //             const relayData = doc.data();
    //             // Prepend the status instead of appending, so it builds right to left
    //             relayStatusString = (relayData.relay_status === 1 ? '1' : '0') + relayStatusString;
    //         });

    //         // Update the "value" key in Realtime Database with the concatenated status string
    //         const valueRef = ref(realtimeDb, 'value');
    //         await set(valueRef, relayStatusString);

    //         // Convert binary string (relayStatusString) to hexadecimal
    //         const hexRelayStatusString = parseInt(relayStatusString, 2).toString(16); // Binary to Hex

    //         // Update the "hex_value" key in Realtime Database with the hexadecimal representation
    //         const hexValueRef = ref(realtimeDb, 'hex_value');
    //         await set(hexValueRef, hexRelayStatusString);

    //         console.log(`Realtime Database updated with relay statuses: ${relayStatusString}`);

    //     } catch (err) {
    //         console.error("Error fetching relays and updating Realtime Database:", err);
    //     }
    // };


    
    const updateRelayStatusesInRealtimeDatabase = async (db, realtimeDb) => {
        try {
            // Create a sorted query to fetch relay documents in ascending order of relay_id
            const relayCollection = collection(db, 'relays');
            const relayQuery = query(relayCollection, orderBy("relay_id", "asc"));
            const relaysSnapshot = await getDocs(relayQuery);
    
            // Initialize an empty string to hold the concatenated relay_status values
            let relayStatusString = '';
    
            // Loop through each relay document, prepending each status to build right-to-left
            relaysSnapshot.forEach(doc => {
                const relayData = doc.data();
                // Prepend the status to build the string from right to left
                relayStatusString = (relayData.relay_status === 1 ? '1' : '0') + relayStatusString;
            });
    
            // Update the "value" key in Realtime Database with the concatenated status string
            const valueRef = ref(realtimeDb, 'value');
            await set(valueRef, relayStatusString);
    
            // Convert binary string (relayStatusString) to hexadecimal
            const hexRelayStatusString = parseInt(relayStatusString, 2).toString(16);
    
            // Update the "hex_value" key in Realtime Database with the hexadecimal representation
            const hexValueRef = ref(realtimeDb, 'hex_value');
            await set(hexValueRef, hexRelayStatusString);
    
            console.log(`Realtime Database updated with relay statuses: ${relayStatusString}`);
    
        } catch (err) {
            console.error("Error fetching relays and updating Realtime Database:", err);
        }
    };
    


  
    const addRelaysToFirestoreWithCustomIDs = async () => {
        try {
            for (let i = 1; i <= 40; i++) {
                // Create a reference to a document with the ID same as the relay_id
                const relayDocRef = doc(db, 'relays', i.toString());
    
                // Set the relay document with custom ID
                await setDoc(relayDocRef, {
                    relay_name: `Door ${i}`,    // Example: Door 8, Door 9, etc.
                    relay_status: 0,            // Initial status set to 0 (off)
                    relay_id: i,                // Relay ID
                    allowed_users: []           // Empty array for allowed users
                });
                console.log(`Relay ${i} added to Firestore with custom ID`);
            }
        } catch (err) {
            console.error("Error adding relays: ", err);
        }
    };

    return (
        <div className="relay-container">
            {/* <DropdownButton id="dropdown-basic-button" title={selectedRelay.relay_name || "Select Relay"}>
                {relays.map((relay) => (
                    <Dropdown.Item
                        key={relay.id}
                        onClick={() => handleSelectChange(relay)}
                    >
                        {relay.relay_name}
                    </Dropdown.Item>
                ))}
            </DropdownButton> */}
            <div id={user.is_admin ? 'relay-component' : 'relay-component-admin'}>
                {relays.map((relay) => (
                    <div key={relay.relay_id} className={(selectedRelay.relay_id == relay.relay_id) ? 'relay-name-container yellow-border' : 'relay-name-container'} onClick={() => handleSelectChange(relay)}>
                        <h1 id="relay-name">{relay.relay_name ?? ''}</h1>
                        {/* <h1>  On</h1> */}
                        <div className="light-switch-container">
                            <div className={`light-bulb ${(relay.relay_status == 1) ? 'on' : 'off'}`}></div>
                            {/* <button >
                        {true ? 'Turn Off' : 'Turn On'}
                    </button> */}
                        </div>
                        <div onClick={(e) => e.stopPropagation()}>
                            <Switch
                                checked={relay.relay_status === 1}  // Reflect the current status in the Switch
                                onChange={(e) => updateRelayStatus(e.target.checked, relay)}  // Pass the toggle value (true/false)
                            />
                        </div>
                    </div>
                ))}
            </div>



        </div>
    );
};

export default RelayDropdown;
